<template>
    <div :class="formGroupClasses">
        <label v-if="label" :for="name">{{ label }}</label>
        <div :class="'input-group' + (icon ? ' left-addon' : '')">
            <span v-if="addonBefore" class="input-group-prepend">
                <span class="input-group-text" v-html="addonBefore"></span>
            </span>
            <i v-if="icon" :class="'fa ' + icon"></i>
            <input 
                @change="$emit('change', $event.target.value)"
                @input="updateValue($event.target.value)"
                @keyup="$emit('keyup', $event)"
                @keydown="$emit('keydown', $event)"
                @blur="$emit('blur', $event)"
                :id="id" 
                :type="type" 
                :class="controlClasses" 
                :name="name" 
                :value="value" 
                :disabled="disabled"
                :placeholder="placeholder"
                :autocomplete="autocomplete">
            <span v-if="addonAppend" class="input-group-append">
                <span class="input-group-text" v-html="addonAppend"></span>
            </span>
        </div>
        
        <span v-if="errors.has(name)" class="form-control-feedback">
            <strong>{{ errors.first(name) }}</strong>
        </span>
        <slot></slot>
        <p v-if="helpText" class="form-text text-muted" v-html="helpText"></p>
    </div>
</template>

<script>
    import FormValidationErrors from '../../../classes/FormValidationErrors.js';

    export default {
        name: 'VueInput',

        props: {

            label: {},

            id: {
                default() { return _.camelCase(this.label); }
            },

            name: {
                default() { return _.kebabCase(this.label).replace('-', '_'); }
            },

            placeholder: {},

            type: {
                default() { return 'text'; }
            },

            helpText: {},

            value: {},

            icon: {},

            addonBefore: { default() { return ''; } },
            addonAppend: { default() { return ''; } },

            errors: {
                default() { return new FormValidationErrors(); }
            },

            classes: {
                default() { return ''; }
            },

            containerClasses: {
                default() { return ''; }
            },

            disabled: {
                type: Boolean,
                default: false
            },
            autocomplete: {
                type: String,
                default: 'off'
            }
        },

        methods: {

            updateValue(value) {
                this.$emit('input', value);
            }

        },

        computed: {

            formGroupClasses() {
                return 'form-group form-group-'+ _.kebabCase(this.name) + (this.errors.has(this.name) ? ' has-warning' : '')+ ' '+this.containerClasses;
            },

            controlClasses() {
                return 'form-control' + ' form-control-' + this.type + (this.errors.has(this.name) ? ' form-control-warning' : '') + ' ' + this.classes;
            }

        }
    }
</script>